import { AtlassianIcon } from '@atlaskit/logo';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import React from 'react';

const spaLoaderStyles = xcss({
	height: '100vh',
});

const logoStyles = xcss({
	animation: 'loading 2s infinite',
});

export const FullScreenSpaLoader = () => (
	<UFOLoadHold name="spa-loader">
		<Inline alignBlock="center" alignInline="center" grow="fill" xcss={spaLoaderStyles} testId="full-screen-spa-loader">
			<Box xcss={logoStyles}>
				<AtlassianIcon appearance="brand" size="xlarge" />
			</Box>
		</Inline>
	</UFOLoadHold>
);
